export default __webpack_public_path__ + "static/media/linkedin.e17390ed.png";